import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import OrderExchange from "../exchange/orderExchange/orderExchange";
import { useEffect, useState } from "react";

const CoinPairComponent = ({ onLoginClick }) => {
    const location = useLocation();
    const segments = location.pathname.split('/');

    const crypto = segments[2];
    const amount = segments[3];
    const fiat = segments[4];
    const isPair = segments[5] === 'pair';

    const hasValidParams = crypto && amount && fiat && isPair;

    const sliderImages = [
        { image: 'assets/images/Visa.png', title: 'Visa' },
        { image: 'assets/images/paypal.png', title: 'PayPal' },
        { image: 'assets/images/GooglePay.png', title: 'Google Pay' },
        { image: 'assets/images/ApplePay.png', title: 'Apple Pay' },
        { image: 'assets/images/Mastercard.png', title: 'Mastercard' },
        { image: 'assets/images/Amex.png', title: 'Amex' },
        { image: 'assets/images/Discover.png', title: 'Discover' },
        { image: 'assets/images/Stripe.png', title: 'Stripe' },
        { image: 'assets/images/Lemon-Squeezy.png', title: 'Lemon Squeezy' }
    ];

    const [chunkedImages, setChunkedImages] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const updateChunks = () => {
            const size = getChunkSize();
            setChunkedImages(chunkArray(sliderImages, size));
            // setTimeout(() => {
            //     if (document.getElementById("next-cus-cor")) {
            //         document.getElementById("next-cus-cor").click();
            //     }
            // }, 5000);
            // if (document.getElementsByClassName("cus-carousel-div").length) {
            //     document.getElementsByClassName("cus-carousel-div")[0].classList.add("active");
            // }
        };

        updateChunks(); // Run on mount
        const timeoutId = setInterval(slideForce, 3000);

        window.addEventListener('resize', updateChunks); // Run on resize
        return () => {
            window.removeEventListener('resize', updateChunks);
            clearInterval(timeoutId);
        }
    }, []);

    const slideForce = () => {
        const isDropdownOpen = document.querySelector('.dropdown-menu.show'); // or check for `.show`
        if (isDropdownOpen) return;

        const nextBtn = document.getElementById("next-cus-cor");
        if (nextBtn) {
            nextBtn.click(); // 🚀 Triggers the Bootstrap slide manually
        }
    };

    const getChunkSize = () => {
        const width = window.innerWidth;
        if (width >= 1100) return 6;   // large screens
        if (width >= 892) return 4;    // medium
        if (width >= 476) return 2;    // small
        return 1;                      // extra small
    };

    const chunkArray = (arr, size) => {
        const result = [];
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, i + size));
        }
        return result;
    };

    // const chunkedImages = chunkArray(sliderImages, 6);

    const handleStartExchange = () => {
        if (localStorage.getItem("token")) {
            navigate(`/dashboard`);
        } else {
            onLoginClick();
        }
    }

    return (
        <>
            <section className='hearo-wrap'>
                <div className='container'>

                    {/* <!--=========Bread Crum!=====================--> */}
                    <div className='bread-crum'>

                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">{crypto} to {fiat}</li>
                            </ol>
                        </nav>

                    </div>
                    {/* <!--=========Bread Crum!=====================--> */}
                </div>

                <div className='container hero-bx padding-top-bot'>

                    {/* <!--exchange part!--> */}
                    <div className='row align-items-center'>
                        <div className='col-xl-7'>
                            <div className='trust-badge'>
                                <img src='/assets/images/avatars.png' />
                                <span>Trusted by 300+ happy customers</span>
                            </div>
                            <h1 className='hero-title'>Exchange ⌁ Crypto Easily & Securely</h1>
                            <p>A clear interface, transparent process, and full compliance with the law. Use Kittrow Investments s.r.o. for real-life needs — from sending money to loved ones to paying important bills.</p>
                        </div>

                        <div className='col-xl-5'>
                            {hasValidParams && (
                                <OrderExchange onLoginClick={onLoginClick} tabId="coinPair-home" fromUrl={true} crypto={crypto} amount={amount} fiat={fiat} />
                            )}
                        </div>
                    </div>
                </div>

                {/* <!--exchange part!--> */}

                <div className='container brand-bar'>

                    {/* <!--=============brand logos!--> */}


                    {/* <p class="elementTitle elementTitleMargin">Trends</p> */}
                    <div id="carouselExampleControls" className="carousel slide" data-ride="carousel" data-interval="3000">
                        {/* <div id="carouselExampleControls" class="carousel slide" data-intervall="false"> */}
                        <div className="carousel-inner">
                            {chunkedImages.map((group, index) => (
                                <div className={`cus-carousel-div carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
                                    <div className="row">
                                        {group.map((item, idx) => (
                                            <div className="">
                                                {/* // <div className="col-md-3" key={idx}>
                                            //     <div className="card"> */}
                                                <img
                                                    className="card-img-top"
                                                    src={item.image || "https://images.pexels.com/photos/45982/pexels-photo-45982.jpeg"}
                                                    alt="Card"
                                                />
                                                {/* // {/* <div className="card-body">
                                                    //     <p className="card-text">{item.title || "Card Item"}</p>
                                                    // </div>
                                            //     </div>
                                            // </div> */}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" id="next-cus-cor" href="#carouselExampleControls" role="button" data-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>

                    {/* <ul>
                        <li><img src='/assets/images/Visa.png' /></li>
                        <li><img src='/assets/images/paypal.png' /></li>
                        <li><img src='/assets/images/GooglePay.png' /></li>
                        <li><img src='/assets/images/ApplePay.png' /></li>
                        <li><img src='/assets/images/Mastercard.png' /></li>
                        <li><img src='/assets/images/Amex.png' /></li>
                        <li><img src='/assets/images/Discover.png' /></li>
                        <li><img src='/assets/images/Stripe.png' /></li>
                        <li><img src='/assets/images/Lemon-Squeezy.png' /></li>
                    </ul> */}
                </div>

                {/* <!--=============brand logos!--> */}

                <div className='container feat-part padding-top-bot'>

                    {/* <!--=============Feature Part!--> */}
                    <div className='row'>
                        <div className='col-sm-4'>
                            <div className='feat-wrap'>
                                <div className='icon'><img src='/assets/images/legally.png' /></div>
                                <h3> <div className='icon mob-show'><img src='/assets/images/legally.png' /></div>Legally Registered in the EU</h3>
                                <p>Kittrow Investments s.r.o. is a licensed VASP in Denmark — one of the EU’s most trusted jurisdictions. All transactions follow strict legal standards.</p>
                            </div>
                        </div>
                        <div className='col-sm-4'>
                            <div className='feat-wrap phone-pad'>
                                <div className='icon '><img src='/assets/images/fast.png' /></div>
                                <h3><div className='icon mob-show'><img src='/assets/images/fast.png' /></div>Fast & Instant Payouts</h3>
                                <p>Your funds are delivered in minutes. We partner with top payment networks to ensure maximum speed and reliability.</p>
                            </div>
                        </div>
                        <div className='col-sm-4'>
                            <div className='feat-wrap'>
                                <div className='icon '><img src='/assets/images/personal.png' /></div>
                                <h3> <div className='icon mob-show'><img src='/assets/images/personal.png' /></div> Tailored for Personal Use</h3>
                                <p>Perfect for rent, tuition, healthcare, or family transfers. Full documentation available upon request.</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!--=============Feature Part!--> */}
                <div className="mob-show-box">
                    <div className="container">
                        <div className="btn-part">
                            <button className="btn buy-btn" onClick={handleStartExchange}>Buy Crypto now</button>
                        </div>

                    </div>
                </div>
            </section>

            {/* <!--===================How to Work!======================--> */}

            <section className='container how-work sec-pad-t'>
                <h2 className='sec-title'>How to use</h2>
                <div className='row'>
                    <div className='col-md-4'>
                        <div className='how-wrap'>
                            <div className='icon'><img src='/assets/images/currency.png' /></div>
                            <h3><div className='icon mob-show'><img src='/assets/images/currency.png' /></div>1. Choose Currency</h3>
                            <p>Select the cryptocurrency you want to sell and the one you want to receive</p>
                            <div className='stp-img'><img src='/assets/images/step1.png' /></div>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='how-wrap phone-pad'>
                            <div className='icon'><img src='/assets/images/depsit.png' /></div>
                            <h3> <div className='icon mob-show'><img src='/assets/images/depsit.png' /></div> 2. Make a Deposit</h3>
                            <p>Send the required amount to the provided wallet address. We start processing instantly</p>
                            <div className='stp-img'><img src='/assets/images/step2.png' /></div>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='how-wrap'>
                            <div className='icon'><img src='/assets/images/funds.png' /></div>
                            <h3><div className='icon mob-show'><img src='/assets/images/funds.png' /></div> 3. Receive Your Funds</h3>
                            <p>We’ll send the funds to your wallet right after confirming the transaction</p>
                            <div className='stp-img'><img src='/assets/images/step3.png' /></div>
                        </div>
                    </div>
                </div>
                <div className='button-group'>
                    <Link to='/how-it-works' className='btn lm-btn'>Learn more</Link>
                </div>
            </section>

            {/* <!--========================Kittrow in Number!===============--> */}

            <section className='container kit-numb sec-pad-t'>
                <h2 className='sec-title'>Kittrow Investments s.r.o. in numbers</h2>
                <div className='row'>
                    <div className='col-md-3 col-6'>
                        <div className='kit-wrap'>
                            <div className='icon'><img src='/assets/images/calendar.png' /></div>
                            <p>Transfers per month</p>
                            <h3>1200+</h3>
                        </div>
                    </div>
                    <div className='col-md-3 col-6'>
                        <div className='kit-wrap'>
                            <div className='icon'><img src='/assets/images/earth.png' /></div>
                            <p>Countries served</p>
                            <h3>35+</h3>
                        </div>
                    </div>
                    <div className='col-md-3 col-6'>
                        <div className='kit-wrap phone-mg-top'>
                            <div className='icon'><img src='/assets/images/personal1.png' /></div>
                            <p>Monthly active user </p>
                            <h3>5000+</h3>
                        </div>
                    </div>
                    <div className='col-md-3 col-6'>
                        <div className='kit-wrap phone-mg-top'>
                            <div className='icon'><img src='/assets/images/support.png' /></div>
                            <p>Customer support</p>
                            <h3>24/7</h3>
                        </div>
                    </div>
                </div>
            </section>

            {/* <!--===================Fully section!=================--> */}

            <section className='container sec-pad-t'>
                <div className='fully-complint'>
                    <div className='row justify-content-center'>
                        <div className='col-xl-7 col-md-10'>
                            <h2>Fully compliant with <br /><span>AML5 / EU VASP</span> standards</h2>
                            <p>Kittrow Investments s.r.o. is officially registered as a Virtual Asset Service Provider (VASP) in the EU and operates under the AML5 directive, ensuring full legal transparency.</p>
                            <div className='button-group'>
                                <Link to='/aml-kyc' className='btn lm-btn-white'>Learn more</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <!--===================Explore section!=================--> */}
            <section className='container sec-pad-t'>
                <div className='exp-part'>
                    <div className='row justify-content-center'>
                        <div className='col-xl-7 col-md-10'>
                            <h2 className='sec-title text-center'>Explore Other Available Pairs</h2>
                            <p className='text-center'>Looking for a different exchange? We support dozens of crypto pairs to suit your needs. Swap instantly between popular coins with ease.</p>
                        </div>
                    </div>
                    <div className='row'>
                        {/* <!--=====Button Row!============--> */}
                        <div className='col-md-4'>
                            <Link to="/coin/USDC/1/USD/pair" className='pair-btn'>
                                <img src='/assets/images/usdc.png' />
                                <span>USDC to USD</span>
                            </Link>
                        </div>
                        <div className='col-md-4'>
                            <Link to="/coin/ETH/1/USD/pair" className='pair-btn'>
                                <img src='/assets/images/eth-usd.png' />
                                <span>ETH to USD</span>
                            </Link>
                        </div>
                        <div className='col-md-4'>
                            <Link to="/coin/USDT/1/USD/pair" className='pair-btn'>
                                <img src='/assets/images/usdt-usd.png' />
                                <span>USDT to USD</span>
                            </Link>
                        </div>
                        <div className='col-md-4'>
                            <Link to="/coin/BTC/1/EUR/pair" className='pair-btn'>
                                <img src='/assets/images/btc.png' />
                                <span>BTC to EUR</span>
                            </Link>
                        </div>
                        <div className='col-md-4'>
                            <Link to="/coin/USDC/1/EUR/pair" className='pair-btn'>
                                <img src='/assets/images/usdc-eur.png' />
                                <span>USDC to EUR</span>
                            </Link>
                        </div>
                        <div className='col-md-4'>
                            <Link to="/coin/ETH/1/EUR/pair" className='pair-btn'>
                                <img src='/assets/images/eth-eur.png' />
                                <span>ETH to EUR</span>
                            </Link>
                        </div>
                    </div>
                    {/* <!--=====Button Row!============--> */}
                    <div className='button-group'>
                        <Link to='#' className='btn lm-btn'>Show more</Link>
                    </div>
                </div>
            </section>

            {/* <!--===================Swap section!=================--> */}

            <section className='container sec-pad-t'>
                <div className='swap-part'>
                    <div className='row justify-content-center'>
                        <div className='col-xl-7 col-md-10'>
                            <div className='kit-logo'><img src='/assets/images/logo-bg.png' /></div>
                            <h2>Swap Crypto & Fiat Instantly</h2>
                            <p>Buy crypto with your local currency or convert it back — safely and in seconds. Kittrow Investments s.r.o. makes fiat-to-crypto exchange simple, secure, and lightning-fast. No hidden fees, no hassle.</p>
                            <div className='button-group'>
                                {/* <Link to='/' className='btn lm-btn-blue'>Start Exchanging Now</Link> */}
                                <button type="button" onClick={handleStartExchange} className='btn lm-btn-blue cus-btn-hover-affect'>Start Exchanging Now</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <!--===================FAQ Help section!=================--> */}

            <section className='container sec-pad-t'>
                <div className='row justify-content-center'>
                    <div className='col-xl-7 col-md-10'>
                        <div className='faq-part'>
                            <h2 className='sec-title'>Need some help?</h2>
                            <p>Our support team is here 24/7 to assist you with any questions about your crypto exchange experience. Fast, friendly, and always ready to help.</p>
                            <div className='faq-quest'>
                                <div className="accordion accordion-flush" id="accordionFlushExample">
                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                                How long does a crypto exchange take?
                                            </button>
                                        </h4>
                                        <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                            <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the first item’s accordion body.</div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                                What should I do if my transaction is stuck or delayed?
                                            </button>
                                        </h4>
                                        <div id="flush-collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                            <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the second item’s accordion body. Let’s imagine this being filled with some actual content.</div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                                                Is KYC required for making an exchange?
                                            </button>
                                        </h4>
                                        <div id="flush-collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                            <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the third item’s accordion body. Nothing more exciting happening here in terms of content, but just filling up the space to make it look, at least at first glance, a bit more representative of how this would look in a real-world application.</div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapsefour" aria-expanded="false" aria-controls="flush-collapsefour">
                                                What cryptocurrency do you support?
                                            </button>
                                        </h4>
                                        <div id="flush-collapsefour" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                            <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the third item’s accordion body. Nothing more exciting happening here in terms of content, but just filling up the space to make it look, at least at first glance, a bit more representative of how this would look in a real-world application.</div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h4 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapsefive" aria-expanded="false" aria-controls="flush-collapsefive">
                                                Can I cancel an exchange after sending crypto?
                                            </button>
                                        </h4>
                                        <div id="flush-collapsefive" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                            <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the third item’s accordion body. Nothing more exciting happening here in terms of content, but just filling up the space to make it look, at least at first glance, a bit more representative of how this would look in a real-world application.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="button-group">
                                <Link to="/faq" className="btn lm-btn">More answers</Link>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <div className='sec-pad-t'></div>
            {/* <!--=============Spacer!===========--></div> */}
        </>
    )

}

export default CoinPairComponent;